import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import userReducer from "../features/layers/layerslice";
import layervisualiseReducer from "../features/layers/layervisualiseslice";
import overlaylayerReducer from "../features/layers/overlaylayerslice";
import baselayerReducer from "../features/layers/baselayerslice"
import appReducer from "../features/layers/appslice"
import mapStateReducer from "../features/maps/mapStateSlice"
import infoReducer from "../features/layers/infoboxslice"
import layerInfoReducer from "../features/layers/layerinfoslice"
import swipelayerReducer from "../features/layers/swipemapslice"
import mapzoomReucer from "../features/maps/mapZoomSlice"
import toolsReducer from "../features/tools/toolsSlice";

import analyticsReducers from "../features/layers/analyticsslice";
import cqlDataSlice from "../features/layers/cqlDataSlice";
import mapZAB from "../features/maps/mapZoomandBounds";
export default configureStore({
  reducer: {
    user: userReducer,
    layervisualise: layervisualiseReducer,
    overlaylayer:overlaylayerReducer,
    baselayer:baselayerReducer,
    apps:appReducer,
    info:infoReducer,
    tools: toolsReducer,
    mapstate: mapStateReducer,
    layerinfo:layerInfoReducer,
    swipelayer:swipelayerReducer,
    mapzoom: mapzoomReucer,
    analysticsvisualise:analyticsReducers,
    cqldata: cqlDataSlice,
    mapstateZAB: mapZAB,
  },
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
});